import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import IconBox from '../../IconBox';

import './PageTitleBar.scss';

const PageTitleBar = ({ className = '', header = '', subheader = '', icon = null, iconLabel = null }) => {
	return (
		<div className={classNames('PageTitleBar', className)}>
			{icon && <IconBox icon={icon} iconLabel={iconLabel} />}
			{(header || subheader) && (
				<div className='PageTitleBar__title'>
					{header && <h1 className='PageTitleBar__header'>{header}</h1>}
					{subheader && <h2 className='PageTitleBar__subheader'>{subheader}</h2>}
				</div>
			)}
		</div>
	);
};

PageTitleBar.propTypes = {
	className: PropTypes.string,
	header: PropTypes.node,
	subheader: PropTypes.node,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	iconLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default PageTitleBar;
